import { ItemSearchResults } from '../types/item-search-results';

export function mapSearchResults<TResult = unknown, TOutput = unknown>(
  searchResults: ItemSearchResults<TResult>,
  mapper: (child: TResult, index: number, array: TResult[]) => TOutput,
  defaultValue: TOutput[] | undefined = undefined
) {
  const result = searchResults.results?.map(mapper) ?? defaultValue;
  return result;
}
